import React, { useState, useEffect } from 'react'
import './style.scss'
import { PowerBIEmbed } from 'powerbi-client-react';
import { useAuth } from './../../context/Auth'
import { models } from 'powerbi-client';

import { Container } from './../../components/Layout'

import api from './../../api'
import PageTracker from '../../components/Page/PageTracker';


function PowerBi() {

    const { getUser } = useAuth()
    const usuario = getUser()
    // PowerBI Report object (to be received via callback)
    const [report, setReport] = useState();
    // API end-point url to get embed config

    // Report config useState hook
    // TODO useEffect calling singIn
    const [reportConfig, setReportConfig] = useState({
    });

    // Map of event handlers to be applied to the embedding report
    const eventHandlersMap = new Map([
        ['loaded', function () {
            console.log('Report has loaded');
        }],
        ['rendered', function () {
            console.log('Report has rendered');
        }],
        ['error', function (event) {
            if (event) {
                console.error(event.detail);
            }
        }]
    ]);

    useEffect(() => {
        // Fetch sample report's config (eg. embedUrl and AccessToken) for embedding
        const signIn = (async () => {
            const _reportConfig = await api.post('bis/embeddedReport', {})
            // let _reportConfig = { data: [] }
            // _reportConfig.data.EmbedToken = "H4sIAAAAAAAEAB2Wxw60CA6E3-W_MhIZmpHmQA5NznAj55xZ7btv75zti7-yq_yfP2by9FOS__n7T4uEn08GfAtzU0uln0wJ1ac3FWSd7bJ-yEyEx5O0GTptCCLSo89PSbRmD4cgrvXGdqMBQtM3LmuT3ppKHDvt0l05HQXCYfXdWeGjI13c2_a3VOs9piJEOQ2LTAPJZ9gUqlnOgY7Q7jptrEFV2VjWhRGB53bKFFrYuXQnzdVY-NVqzSoI15lvJo2e3luM8jBRP8mE0Z4z7HOS-32SCOSd8nhGBXIGx3A7w6HaEO7lHTI6gRAD2bQz9nqUFYMTtnGaNAbL8o3kvGoUiWSAPMvABJbfccxpUJ29-5tly3CN5170wE3Nll3JAOIJfBj7pSKp94lURlyYzDM8V-MILTgx1D1L_p6omBBxYb1UK0j633tZVTZbXzzrSsY_pRvkrGA26SncYid30awqwbNQMgoDoIj6IIbF9aG7HHGQFtrJciZZ_mpgLRU-whOyUnfrbXqzgX5RofwAV3VBeZEQRUp3FPYWpv5RtCnrwO9mji8EN6IknyWalSbwFFwT5Svk0zAx5XhfOWv-wV1Oey18s03oBGaR1K9rAbrN-wqIxUQSFWaxR9aF7SSbrPW319TEGn2s_YnaOLXBfd70Ltme6DJoI3E7Ys7XjynX3NRox8IptS10SwYtgRgAmCWksqBatL9ZhKCpo-wcOhbOBEs4i2TM7bdUZadkXuSrSQjkDFE40FICfVww7kSEp3-qDPgCw1AcNiEr2plxxIl4MIS5Cw6nA7q1n-ImkgUlSeUXS1Jy0B8a3jWHWMjmoD25PMY0WW_KBbRL4AQHheg7MriQo3lISXpdxwjvPpQshXuCbg1gKpMCOsYt9emdomfjo3VcvmGCcjkoXh0FPJAGMVoVUH9RxAtYHqGnibGQS6EQw9TlW7MQFqTDXstwvsw0aA6fRRmELjhXVnNngV3S8E4tNQUFZ-n7HjCsTb3SdM9SDkii60u11ATngXk9b3rcMJsBPaWNHNZhHwrkweeQvGKy4TfCYqKH_XSv3MgdB-OBM5rGnH3pnVBTriZE6tZe8_ACPdX8GuU3c7haQYRc456PpIQLrQHot0Wm7UFP9iIUfjztouz6ke4an_xUTrGy7xWUwgDihneUPlMAL41gz9hScFq3bYBibqqdHu-KEhr6OUCj7dOkps06N8E0ZtszDMGgFbxWml6hUuyvVqO6UZYG35eBq2rG0BLnDl6s0XJ2ask6TWD7eJAEnlIbMtLmtSLACW0gm77_NYk5Da-Y55i8duxRJ64492l2CVLvNfG5qqxm_mwkJ541xTGEU9t6XgligORPtukbixQvxtMk7gc-vuNuywjJ7QdFRpCoNQ9XI_3kmvMj0pJyefJkitgbc36DkRySBMH26lFHxOVt7f7CWtY2Lc2Lgd_eCzgLyeEYYTF2-A7KQUiLykLMksfTgSRsImB1mfNLIDAp_PUkgR4Um3YR6Tu5vj9SCN8TxbVSivXd9kw-806VeHPFv6l0iKn6HXNlZvwN6BxFQJa0cXWD0GahP89Aw_FYBli2fr2ctlFy17384krgfQGU-5AuMKhfJeIGiINLCPavGqEaEaw_WJAndfemqN-_W21M4huq8jlceofrEygy3fe7KI8OGZhkfnCCvyIQt5obNLPGxEnTR0HC9o_jqJCs9FyFbcRdz2SidIiucVWpfhJoQZZAW9Fnk1FFgOE6HhUCTTV_rAjRJ5Toc2guRtqtcpOBaDChImHkHfjieTwQ66GSKmmEp549JbL12fEwJsWByjP9rM4pTiHKKV6FCO-4NIdk4gDcj3_kqMNWID-_vuHT52_xd7ywbkY9o70Nx0JcbBr8xacszV58LA3lzJIi5K8HkCxMRZZGJBOHmqHiPvGvb7GcGGk4r1tiF2a9Eci0-hSkVEbJ5gg450bG64woMyQEttjLZAHsiLS_Mxg_7s8x6g_6sWEqOZ2TRYUTcptSYJXQRIJ1Fxo6K_2hpThjOJu4C7FkUh1F8aQhgcmPFL45Kr0a3T51T7MVIIqCDGKrDK1SXgZXAZx4-pnRTjuJfCxURrzt4SYMmqxJKaOE0Yzo04t22JXqvPQN4hZi_4SWGzt-QQCMmg3IGZlbcRyC2X6mxzVe8MZ6D1sPvxTQGaStw11zH4w_pSuVYR3mhwePzFo9S7yuF3zL-tpe-WkHkSqhVyzAjZhN9hyCuJ1_k5mTu2Tfue23d5DycZGj1cfYVRDZF8BKC8mKqkXZnqgSPKqmor9Fn_0coeCC-zlfj3vTfqVBkHZQNXWf_SUsRZ8yf883g6K33O5EMlmagaUUptgofm-fnVSpGpBsnX28R9dJkoLWp-bcyzymR2GDKefkrJLiqcwnr3Ch9_NNhaNzoRpc5hWWsWJWTbjyunpDSAeSrH_-_PWHXZ95n77F83udSoFQPM61046hny4XN4_0zjaNRXsxJTHEm8LIGjCE0Jl6lXGG8zEPkoIBvpTeM7_05g8tnfvTi21tEqRo3Lt0japTBzzAONm2zLhen46KE-N-T_Gy4L1MUEDJ2wgi7XLjS7QQywQQy_pILeR2zWcn9FOZb_HCtQaDHTl20LyGK9xwPn5GVQIm8fLYVc98mhC6KEKP6-8Pi5TF7Z1PW-uLaQVgk_rK1jrOhi2lGVvcFyJ89YJb1fbZEoetOcoeuqevihCaswruJGzq1sFxjTg_2EXoVJ7wYHef2INBXb8iou89nincH0btcZMUEbiHafcFT7QNic82AnHB84rX53NjY6P1z7-Yn7kuVtn_UXZG5evF6xTRmUYHfWXqzRZc_3Y5TTUm-7EWvzZIIhvcDVggQBKUmul9BpwRlBf2S30wTas8-XFlevVpeV16oBLLdZnMMxxiZT_2H-hS9b7OviE5yBE6cCBugFgJdYCfdWdLqTBDQE77kuUwzrjZIk8o-HozWe1SkOUDZqeCQ4QmcxSPfTJg_9ivGpvLk_SFoC_odHHjoOb2gyLMfkrZZm4oDv52dMEGyCsaFx4_eH2Bvk6nemY4kuO2D00lHD2GuvzIQNIMgE2Y_Kgs5dRC4iyCUGTSsCROpx9rBEdalG2W3VZECze_rAhTgajGuTdrIfz7Gcokr7mmJQ04QfMGPLBgKR21-qzNKZJQhFavsMHgUWRilbCk6gNfWCuJ-P-Y__s_FfXjTC4MAAA=.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUJSQVpJTC1TT1VUSC1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsibW9kZXJuRW1iZWQiOmZhbHNlfX0=";
            // _reportConfig.data.EmbedUrl = "https://app.powerbi.com/reportEmbed?reportId=e9f70d2a-989d-4c1f-a9cc-95eba4d8eff8&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUJSQVpJTC1TT1VUSC1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsibW9kZXJuRW1iZWQiOnRydWV9fQ%3d%3d";

            // console.log(_reportConfig)

            const filter = {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: "ES_SP_ResumoDREProjetoBonificacao_FormatoImpresso",
                    column: "Lider"
                },
                filterType: 1,
                displaySettings: {
                    isHiddenInViewMode: true
                },
                operator: "In",
                values: [
                    usuario.nome_consultor
                ],
                requireSingleSelection: false
            };

            console.log(filter)
            // Set the fetched embedUrl and embedToken in the report config
            setReportConfig(prevState => ({
                ...prevState,
                type: 'report',
                tokenType: models.TokenType.Embed,
                embedUrl: _reportConfig.data.EmbedUrl,
                accessToken: _reportConfig.data.EmbedToken,
                settings: {
                    filterPaneEnabled: true
                },
                filters: [filter]
            }));
        });

        signIn();


    }, [usuario.nome_consultor]);


    return (
        <>
            <PageTracker pageUrl="/powerbi" />
            <Container
                classAdd='semHomeClass'
            >
                {reportConfig.embedUrl &&

                    <div>
                        <PowerBIEmbed
                            embedConfig={reportConfig}
                            eventHandlers={eventHandlersMap}
                            cssClassName={"report-style-class"}
                            getEmbeddedComponent={(embedObject) => {
                                console.log(`Embedded object of type "${embedObject.embedtype}" received`);
                                setReport(embedObject)
                            }}

                        />
                    </div>
                }
            </Container>
        </>
    )
}

export default PowerBi